import React, {useState, useCallback} from 'react';
import t from 'babel-plugin-yate/macro';

import Button from '../../components/Button';

import {useDispatch} from 'react-redux';
import {getTransactionContract} from '../../store/transaction';
import {handleAutoDownloadFile} from '../../lib/misc';
import CancelTransactionButton from '../CancelTransactionButton';
import Text from '../../components/uiElem/Text';
import {Block} from '../../components/uiElem';

function TransactionStep2(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [hasDownloadedContract, setHasDownloadedContract] = useState(false);
  const {uuid, patchHandler} = props;
  const dispatch = useDispatch();

  const handleDownloadContract = useCallback(async () => {
    setIsLoading(true);
    const res = await dispatch(getTransactionContract(uuid));
    setIsLoading(false);

    if (res?.ok) {
      handleAutoDownloadFile(res);
      setHasDownloadedContract(true);
    }
  }, [dispatch, uuid]);

  return (
    <>
      <div className="lg:flex -ml-10">
        <div className="lg:w-full pl-10">
          <div className="mb-4 lg:w-2/3 m-auto">
            <Block
              heading={t`Transaction document`}
              descriptionClassName="jupiter">
              <div className="py-8 p-4">
                <div className="mb-8">
                  <Text ui="neptune">{t`Generate transaction document and continue.`}</Text>
                </div>

                <Button
                  color="blue"
                  title={t`Generate transaction document`}
                  loading={isLoading}
                  customProps={{disabled: isLoading}}
                  onClick={handleDownloadContract}
                />
              </div>
            </Block>
          </div>
        </div>
      </div>

      <div className="py-6 flex justify-between">
        <div className="pr-2 flex-shrink-0">
          <CancelTransactionButton uuid={uuid} />
        </div>
        <div className="w-64 mx-auto sm:mr-0">
          <Button
            fullWidth
            color="orange"
            border={false}
            title={t`Continue`}
            customProps={{disabled: !hasDownloadedContract}}
            onClick={() => {
              patchHandler({});
            }}
          />
        </div>
      </div>
    </>
  );
}

export default TransactionStep2;
